export const Form = ({ onSubmit, children, ...props }) => {
  return (
    <form className="uk-form" onSubmit={onSubmit} {...props}>
      {children}
    </form>
  );
};

export default Form;
